import React from 'react';
import ProjectSidebarComponent from './ProjectSidebarComponent';
import { PageHeader } from '../../components';

const RawWaterPreTreatment: React.FC = () => {
  return (
    <>
      <PageHeader title="Raw Water Pre-treatment" breadcrumbs={[{ label: "Projects", path: "/projects" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-4.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Raw Water Pre-treatment</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Raw water pre-treatment is the crucial first step in any industrial or municipal water treatment system. It involves the removal of physical, chemical, and biological impurities from surface or groundwater sources before further processing. At Wasser Technochem (I) Ltd., we design and execute customized pre-treatment systems that ensure reliable, high-quality water for downstream treatment units.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-water text-primary me-2"></i>Power Plants (Cooling Tower Makeup)</p>
              <p><i className="fa fa-water text-primary me-2"></i>Process Industries (Textile, Paper, Chemical)</p>
              <p><i className="fa fa-water text-primary me-2"></i>Municipal Drinking Water Supply</p>
              <p><i className="fa fa-water text-primary me-2"></i>Boiler Feed Water Conditioning</p>
              <p><i className="fa fa-water text-primary me-2"></i>RO/UF/EDI Pre-conditioning</p>

              <h3 className="mb-4">Our Capabilities</h3>
              <p className="mb-4">WTIL offers complete solutions for raw water treatment, covering design, supply, erection, and commissioning of the following units:</p>
              
              <h4 className="mb-3">Treatment Units:</h4>
              <div className="mb-4">
                <h5><i className="fa fa-cog text-primary me-2"></i>Coagulation & Flocculation Units</h5>
                <p className="ms-4">Chemical dosing systems for destabilizing suspended particles and enhancing settling efficiency.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-cog text-primary me-2"></i>Clarifiers / Lamella Settlers</h5>
                <p className="ms-4">For sedimentation of heavy solids with options for inclined plate and tube settler designs.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-cog text-primary me-2"></i>Flash Mixers and Flocculators</h5>
                <p className="ms-4">Engineered to optimize mixing times and floc formation using low-speed agitators.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-cog text-primary me-2"></i>Pressure Sand Filters (PSF)</h5>
                <p className="ms-4">Used to remove turbidity, suspended solids, and organic matter.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-cog text-primary me-2"></i>Dual Media Filters (DMF)</h5>
                <p className="ms-4">Enhanced filtration using layers of graded gravel, sand, and anthracite for improved performance.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-cog text-primary me-2"></i>Oil & Grease Traps</h5>
                <p className="ms-4">Essential for pre-treating water from petroleum-based industries and oily effluents.</p>
              </div>

              <h3 className="mb-4">Key Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>Enhanced efficiency of downstream RO/UF/DM units</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Reduced fouling, scaling, and corrosion risks</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Lower chemical and membrane replacement costs</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Improved reliability and life of the entire plant</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p className="mb-4">With over two decades of experience, WTIL brings unmatched expertise in designing site-specific raw water treatment systems for Indian industries. We offer:</p>
              <p><i className="fa fa-star text-warning me-2"></i>Tailor-made solutions backed by pilot studies</p>
              <p><i className="fa fa-star text-warning me-2"></i>In-house engineering and fabrication</p>
              <p><i className="fa fa-star text-warning me-2"></i>Rapid deployment with full automation support</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Compliance with CPCB & BIS water quality standards</p>
            </div>

            <div className="col-lg-4">
              <ProjectSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default RawWaterPreTreatment;
